// src/config/appConfig.js

const CONFIG = process.env.REACT_APP_CONFIG_DATA;

const getConfig = () => {
  return {
    SERVICIO:
      sessionStorage.getItem("CONSULTA") ?? process.env.REACT_APP_SERVICIO,
    IMAGENOLOGIA:
      sessionStorage.getItem("IMAGEN") ?? process.env.REACT_APP_SERVICIO_IMG,
    PROCEDIMIENTO:
      sessionStorage.getItem("PROCEDIMIENTO") ??
      process.env.REACT_APP_SERVICIO_PCD,
    SUCURSAL: sessionStorage.getItem("SUCURSAL"),
  };
};

export const initConfig = (data) => {
  const localConfig = data ? data[CONFIG] : null;

  sessionStorage.setItem("CONSULTA", localConfig?.CONSULTA ?? "");
  sessionStorage.setItem("IMAGEN", localConfig?.IMAGEN ?? "");
  sessionStorage.setItem("PROCEDIMIENTO", localConfig?.PROCED ?? "");
  sessionStorage.setItem("SUCURSAL", localConfig?.sucursales ?? "");
};

export default getConfig;
